require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-code-fellows-awarded-switchups-badge-of-excellence.json") })
        }
      }, "path---blog-code-fellows-awarded-switchups-badge-of-excellence");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-code-fellows-awarded-switchups-badge-of-excellence!./.cache/json/blog-code-fellows-awarded-switchups-badge-of-excellence.json
// module id = 754
// module chunks = 231608221292675